import varAxios from "../../../Comman/axios";
import {GetDeletedUsersUrl,deleteRejectedUserUrl,GetApprovedUserByIdUrl,GetRegionListUrl} from '../../../Comman/apiEndPoints';

export const Fetch_Deleted_List = "Fetch_Deleted_List";
export const Update_Request = "Update_Request";
export const Update_Delete_Response = "Update_Delete_Response";
export const Update_Approve_Response = "Update_Approve_Response";
export const Fetch_All_Region_Data1 = "Fetch_All_Region_Data1";
export function getDeletedUserList(RegionId,dispatch){
    return(dispatch) =>{
        dispatch(updateRequest());
        return varAxios.post(GetDeletedUsersUrl,RegionId,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
        .then(response => {
           dispatch(
             fetchDeletedList({
                 errorCode : response.data.errorCode,
                 statusCode : response.data.statusCode,
                 deletedList : response.data.Users
              }));
        })
        .catch((error) => {
           console.log("error",error);
       })
    }
}
/* export function getDeletedUserList(){
    return(dispatch) =>{
        dispatch(updateRequest());
        return varAxios.get(GetDeletedUsersUrl)
        .then(response => {
           dispatch(
             fetchDeletedList({
                 errorCode : response.data.errorCode,
                 statusCode : response.data.statusCode,
                 deletedList : response.data.Users
              }));
        })
        .catch((error) => {
           console.log("error",error);
       })
    }
} */
export function fetchDeletedList({errorCode,statusCode,deletedList}){
    return{
        type : Fetch_Deleted_List,
        errorCode,
        statusCode,
        deletedList
    }
}
export function deleteUser(requestPayload,Region) {
    return (dispatch) => {
        dispatch(updateRequest());
  
        return varAxios.delete(deleteRejectedUserUrl,{data:requestPayload} ,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                  updateDeleteResponse(response.data.Message,
                    response.data.errorCode,response.data.statusCode)
                );
                this.getDeletedUserList({RegionId:Region})
            })
            .catch((error) => {
                if(error.response.data.statusCode==401){
                  alert(error.response.data.Message)
                }
            })
    }
  }
export function updateRequest() {
    return {
      type : Update_Request
    }
}
export function updateDeleteResponse(message,errorCode,statusCode) {
    return {
      type : Update_Delete_Response,
      message,
      errorCode,
      statusCode
    }
  }
  export function ReApproveUser(requestPayload,Region) {
    return (dispatch) => {
        dispatch(updateRequest());
  
        return varAxios.post(GetApprovedUserByIdUrl,requestPayload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                  updateApproveResponse(response.data.Message,
                    response.data.errorCode,response.data.statusCode,response.data.deleteUsers)
                );
                this.getDeletedUserList({RegionId:Region})
            })
            .catch((error) => {
                if(error.response.data.statusCode==401){
                  alert(error.response.data.Message)
                }
            })
    }
  }
export function updateApproveResponse(message,errorCode,statusCode,list){
  return {
    type : Update_Approve_Response,
    message,
    errorCode,
    statusCode,
    list
  }
}
export function getAllRegionSettings() {
  let requestPayload={
    UserId:sessionStorage.getItem('SuperAdminUserID')
  }
    return(dispatch) =>{
       return varAxios.post(GetRegionListUrl,requestPayload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
       .then(response => {
       
       
        this.getDeletedUserList({RegionId:response.data.regionList[0].ID})
          dispatch(
            fetchAllRegionData({
              errorCode : response.data.errorCode,
              statusCode : response.data.statusCode,
              regionList : response.data.regionList
             }));
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchAllRegionData({errorCode, statusCode, regionList}) {
  return {
    type : Fetch_All_Region_Data1,
    errorCode,
    statusCode,
    regionList
  }
}